(ns ui.gallery.move-popover
  "The 'Move' popover of the selection bar and the folder popover of
   small screens (where the folder tree panel is hidden) of the
   Replicant gallery. Both show the folder chain and the folder tree of
   the gallery: navigating a folder in the popover navigates the whole
   gallery, the selection is kept, and 'Move here' moves the selected
   entries into the folder that is shown then."
  (:require [ui.gallery.folder-tree :as folder-tree]))

(def chevron-up-svg
  [:svg {:xmlns "http://www.w3.org/2000/svg" :viewBox "0 0 24 24" :fill "currentColor"
         :class ["ml-2" "h-5" "w-5"]}
   [:path {:fill-rule "evenodd" :clip-rule "evenodd"
           :d "M11.47 7.72a.75.75 0 011.06 0l7.5 7.5a.75.75 0 11-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 01-1.06-1.06l7.5-7.5z"}]])

(defn backdrop
  "A transparent layer that closes the popover on a click outside."
  [close-actions]
  [:div.fixed.inset-0.z-10
   {:on {:click close-actions}}])

(defn move-popover
  [gallery folder-tree]
  (let [open? (:move-popover? gallery)
        toggle [[:store/assoc-in [:gallery :move-popover?] (not open?)]]]
    [:div.relative.mr-2
     [:button.h-full.group.inline-flex.items-center.rounded-md.bg-secondary-500.hover:bg-secondary-300.px-4.py-2.text-base.font-medium.text-white.focus:outline-none
      {:type "button"
       :on {:click toggle}}
      [:span "Move"]
      chevron-up-svg]
     (when open?
       [:div
        (backdrop toggle)
        [:div.absolute.top-auto.left-0.bottom-0.z-20.w-screen.max-w-sm.lg:max-w-3xl
         {:style {:margin-bottom "50px"}}
         [:div.overflow-hidden.rounded-lg.shadow-lg.ring-1.ring-black.ring-opacity-5
          [:div.bg-gray-50.p-4
           (folder-tree/folder-chain gallery folder-tree)
           (folder-tree/move-folder-list gallery folder-tree)]]]])]))

(defn change-folder-popover
  "The folder chain with a '›' toggle that drops down the folder tree,
   for small screens."
  [gallery folder-tree]
  (let [open? (:mobile-folders? gallery)
        toggle [[:store/assoc-in [:gallery :mobile-folders?] (not open?)]]]
    [:div.relative.mr-2.mb-2
     (folder-tree/folder-chain
       gallery
       folder-tree
       [:button.hover:bg-gray-200.font-bold.text-xl.w-6.bg-gray-100.border.rounded.h-8.shrink-0
        {:type "button"
         :title "Show sub folders"
         :on {:click toggle}}
        "›"])
     (when open?
       [:div
        (backdrop toggle)
        [:div.absolute.z-20.w-screen.max-w-sm.lg:max-w-3xl
         [:div.overflow-hidden.rounded-lg.shadow-lg.ring-1.ring-black.ring-opacity-5
          [:div.bg-gray-50.p-1.flex.flex-col
           {:style {:max-height "50vh"}}
           (folder-tree/folder-list gallery folder-tree)]]]])]))
